import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import { getCardSettings } from 'cards/util/cardSettingsUtils';

class CloseCustomModal extends Component {
  constructor() {
    super();
    this.onSaveData = this.onSaveData.bind(this);
  }

  onSaveData(destination) {
    const { hideModalFn } = this.props;
    hideModalFn();
    window.location.href = destination;
  }

  render() {
    const { projectType, isDigital } = this.props;
    const { urlSlug, label } = getCardSettings(projectType, isDigital);
    const draftUrl = isDigital
      ? '/wedding-planning/projects/digital'
      : '/wedding-planning/projects/drafts';
    return (
      <div>
        <div className="modal-header">
          <h2 className="modal-title">We saved your work</h2>
        </div>
        <div className="modal-body">
          <p className="text-left">
            Visit &ldquo;Your Orders + Drafts&rdquo; to continue customizing your design anytime.
          </p>
        </div>
        <div className="modal-footer">
          <div className="text-group row">
            <ButtonV2 variant="secondary" onClick={() => this.onSaveData(draftUrl)}>
              View Drafts
            </ButtonV2>
            <ButtonV2
              onClick={() => this.onSaveData(`/wedding-planning/${urlSlug}/shop`)}
            >{`Browse ${label}`}</ButtonV2>
          </div>
        </div>
      </div>
    );
  }
}

CloseCustomModal.propTypes = {
  projectType: PropTypes.string,
  hideModalFn: PropTypes.func,
};

export default CloseCustomModal;
